import {
  contractsDestroyMutation,
  leadsContractsListQueryKey,
  opportunitiesContractsListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const DeleteContract = ({
  contract,
  onCancel,
  ...props
}: ActionsType) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { id: leadId, opportunityId } = useParams()

  const { mutate, isPending } = useMutation({
    ...contractsDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsContractsListQueryKey({ path: { lead_id: String(leadId) } })
      ])

      if (opportunityId) {
        invalidateQueries([
          opportunitiesContractsListQueryKey({
            path: { opportunity_id: String(opportunityId) }
          })
        ])
      }
      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!contract.id) return

    mutate({ path: { id: contract.id } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
